export default __webpack_public_path__ + "static/media/benefit6.8b40f8e4.png";